var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFullLayout)?_c(_vm.routeLayout,{key:_vm.currentLocale,tag:"component"},[_c('router-view',{key:_vm.routeKey})],1):_c('v-app',[_c(_vm.routeLayout,{key:_vm.currentLocale,tag:"component"},[_c('router-view',{key:_vm.routeKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }